;(function() {
  'use strict'

  angular.module('app.core').component('gBadge', {
    templateUrl: 'g-badge.html',
    bindings: {
      type: '@',
    },
  })
})()
